import { render, staticRenderFns } from "./NewSalePersonForm.vue?vue&type=template&id=6a806423&"
import script from "./NewSalePersonForm.vue?vue&type=script&lang=js&"
export * from "./NewSalePersonForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports